module.exports = __webpack_public_path__ + "assets/1.63f728ce.jpg";